import store from '@/store';
export var setHeaders = function setHeaders() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (store.getters.token) {
    config['Token'] = store.state.user.token;
    // config['X-Device-Id'] = localStorage.getItem('deviceId');
  }

  return config;
};